module.exports = __webpack_public_path__ + "static/media/PITCH_darker.ddec129f.webp";